import template from './radio-strip.jst.html';

const selectors = {
	element: '[data-element=radio-strip]',
	radio  : '[type=radio]',
	label  : 'label',
	slider : '[data-element=strip-slider]',
};

/**
 * DEFA RadioStrip
 * A horizontal radio button bar for DEFA Automotive Control in Simplify
 * @version 1.0.0
 */

function RadioStrip( element, currentValue ) {
	
	// ---------------------------------------
	// setup
	// ---------------------------------------
	
	let $app,
		$radios,
		$labels,
		$slider,
		$window,
	
		currentIndex,
		numElements,
		appWidth,
		elemWidth,
	
		maxPosX,
		minPosX      = 0, // always
		arrPos,
		posX,
	
		touchStartX,
		touchMoveX,
		moveX,
		longTouch,
	
		triggerHappy = false;
	
	// ---------------------------------------
	// constructor
	// ---------------------------------------
	
	/**
	 * Triggers when this module initializes
	 * @void
	 */
	let init = function ( element, currentValue ) {
		
		// -----------------------------------
		// set vars and elements
		
		$app    = $( element );
		$window = $( window );
		
		let options = $app.find('option')
						  .map(function() {return { value: this.getAttribute('data-value'), title: this.text}} );
		let name = $app.attr('data-name');
		let $newApp = renderHTML(name, options);
		$app.html($newApp);
		$radios = $app.find( selectors.radio );
		$labels = $app.find( selectors.label );
		$slider = $app.find( selectors.slider );
		
		numElements  = $radios.length;
		
		let index = _.findIndex( options, opt => opt.value === currentValue);
		setIndex(index);
		
		// -----------------------------------
		// set position minimums and maximums
		setSizes();
		
		// -----------------------------------
		// set event listeners
		
		$labels.on( 'click', onClickLabel );
		
		// adding passive listeners
		let slider  = $slider.get( 0 ),
			/* global Modernizr */ // TODO Modernize Modernizr
			passive = Modernizr.passiveeventlisteners
					  ? { passive: true }
					  : false;
		
		slider.addEventListener( 'touchstart', onTouchStartApp, passive );
		slider.addEventListener( 'touchmove', onTouchMoveApp, passive );
		slider.addEventListener( 'touchend', onTouchEndApp, passive );
		
		$window.on( 'resize', onWindowResize );
	};
	
	let renderHTML = (name, options) => {
		return template({name, options});
	};
	
	// ---------------------------------------
	// event handlers
	// ---------------------------------------
	
	/**
	 * Triggers when the user starts a touch.
	 * @void
	 */
	let onTouchStartApp = function ( event ) {
		
		// check if flick or long-touch.
		longTouch = false;
		
		setTimeout( function () {
			longTouch = true;
			
			// touch is active, prepare for touch-move to be instant
			$slider.addClass( 'touch-active' );
		}, 200 );
		
		//touchStartX = event.originalEvent.touches[0].pageX;
		touchStartX = event.touches[ 0 ].pageX;
	};
	
	/**
	 * Triggers when the user moves after a touch.
	 * @void
	 */
	let onTouchMoveApp = function ( event ) {
		
		//touchMoveX = event.originalEvent.touches[0].pageX;
		touchMoveX = event.touches[ 0 ].pageX;
		moveX      = -( touchStartX - touchMoveX );
		
		setSlider( moveX );
	};
	
	/**
	 * Triggers when the user ends his touch.
	 * @void
	 */
	let onTouchEndApp = function ( event ) {
		
		$slider.removeClass( 'touch-active' );
		
		let index;
		
		// Flick
		if ( !longTouch ) {
			
			if ( touchStartX > touchMoveX ) {
				index = currentIndex - 1;
				if ( 0 > index ) {
					index = 0;
				}
				
			} else {
				index = currentIndex + 1;
				if ( index > ( numElements - 1 ) ) {
					index = numElements - 1;
				}
			}
			
			// Touch
		} else {
			
			let newPos = getClosest( ( elemWidth * currentIndex ) + moveX );
			
			index = _.findIndex( arrPos, function ( pos ) {
				return ( pos === newPos );
			}
			);
		}
		
		triggerHappy = true;
		setIndex( index );
	};
	
	/**
	 * Triggers when the user clicks on the label
	 * @void
	 */
	let onClickLabel = function ( event ) {
		
		event.preventDefault();
		$slider.removeClass( 'touch-active' );
		
		// from label, get radio, and check that radio button.
		let $target = $( event.target ).closest( selectors.label );
		
		triggerHappy = true;
		let newIndex = _.findIndex( $labels,
			function ( label ) {
				return ( $target.get( 0 ) === label );
			}
		);
		setIndex( newIndex );
	};
	
	/**
	 * Triggers when the app resizes.
	 * @void
	 */
	let onWindowResize = function () {
		
		setSizes();
	};
	
	
	// ---------------------------------------
	// public functions
	// ---------------------------------------
	
	/**
	 * Sets or gets the value of the currently selected radio-button.
	 * @return {string} The value of the currently selected radio-button.
	 */
	this.value = function ( value ) {
		
		if ( value ) {
			setIndex( value );
		}
		
		return val();
	};
	
	
	// ---------------------------------------
	// private functions
	// ---------------------------------------
	
	/**
	 * Gets the closest position to a placement in arrPos.
	 * @return {number} The closest number in arrPos.
	 */
	let getClosest = function ( pos ) {
		
		let tuples = _.map( arrPos, function ( nPos ) {
			return [ nPos, Math.abs( nPos - pos ) ];
		} );
		
		return _.reduce( tuples, function ( memo, val ) {
			return ( memo[ 1 ] < val[ 1 ] ) ? memo : val;
		}, [ -1, 999 ] )[ 0 ];
	};
	
	/**
	 * Sets the application index and initiates all the changes.
	 * @void
	 */
	let setIndex = function ( index ) {
		
		currentIndex = index;
		
		setSlider();
		checkRadio();
		setLabelSelected();
		
		if ( triggerHappy ) {
			triggerHappy = false;
			triggerChange();
		}
	};
	
	/**
	 * Sets vars concerning the sizes of application elements.
	 * @void
	 */
	let setSizes = function () {
		let innerApp = $app.children().eq(0);
		appWidth = innerApp.width();
		
		elemWidth = appWidth / numElements;
		maxPosX   = appWidth - elemWidth;
		
		// create a new array of "snapping" positions
		arrPos = [];
		for ( let i = 0; i < numElements; i++ ) {
			arrPos[ i ] = i * elemWidth;
		}
		
		setIndex( currentIndex );
	};
	
	/**
	 * Moves the slider to cover the background of the label for the checked radio button.
	 * @void
	 */
	let setSlider = function ( offset ) {
		
		offset = offset || 0;
		
		let pos = ( ( elemWidth * currentIndex ) + offset );
		
		// make sure pos is within bounds, and request the slider to move.
		if ( !isNaN( pos ) ) {
			posX = +Math.min( Math.max( pos, minPosX ), maxPosX ) + 'px';
			window.requestAnimationFrame( positionSlider );
		}
	};
	
	/**
	 * Moves the slider to a new position.
	 * @void
	 */
	let positionSlider = function () {
		
		$slider.css( {
			'transform': 'translate3d( %s, 0, 0 )'.replace( '%s', posX ),
			'opacity'  : 1,
		} );
	};
	
	/**
	 * Checks a radio button by index.
	 * @void
	 */
	let checkRadio = function () {
		$radios.eq( currentIndex ).prop( 'checked', true );
	};
	
	/**
	 * Sets the correct label as selected.
	 * @void
	 */
	let setLabelSelected = function ( $target ) {
		
		$labels.removeClass( 'selected' );
		$labels.eq( currentIndex ).addClass( 'selected' );
	};
	
	/**
	 * Returns the currently selected value.
	 * @return {string}  The value of the checked radio-button.
	 */
	let val = function () {
		return $radios.filter( ':checked' ).val().trim();
	};
	
	/**
	 * Triggers a change event from the element with the current radio button value.
	 * @return {string} The current radio button value.
	 */
	let triggerChange = function () {
		$app.trigger( 'change', val() );
	};
	
	
	init( element, currentValue );
	return this;
}

export default RadioStrip;